import script from "./QFZPButtonStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./QFZPButtonStatus.vue?vue&type=script&setup=true&lang=js"

import "./QFZPButtonStatus.vue?vue&type=style&index=0&id=465b818c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-465b818c"]])

export default __exports__